export const GET_EMPLOYEES              = 'GET_EMPLOYEES';
export const GET_EMPLOYEE               = 'GET_EMPLOYEE';
export const LOADING_EMPLOYEES          = 'LOADING_EMPLOYEES';
export const SAVE_LOADING_EMPLOYEES     = 'SAVE_LOADING_EMPLOYEES';
export const GET_ALL_EMPLOYEES          = 'GET_ALL_EMPLOYEES';
export const LOADER_ALL_EMPLOYEES       = 'LOADER_ALL_EMPLOYEES';
export const GET_ALL_EMPLOYEES_FAILD    = 'GET_ALL_EMPLOYEES_FAILD';